import { useQuery } from '@tanstack/react-query';
import type { PfPatientFormRecord } from '@elva/ui';
import { keys } from '@/api/queryKeys';
import { resolvePatientFormToken } from '../api/patientFormReadApi';

/** Same patient-fill access token used by `/api/public/forms/{token}/file`. */
export function usePatientFormAccessToken(
  form: PfPatientFormRecord | null,
  assignmentIdOverride?: string,
) {
  const existing = form?.accessToken?.trim() ?? '';
  const assignmentId = assignmentIdOverride?.trim() || form?.assignmentId?.trim() || '';

  const query = useQuery({
    queryKey: keys.forms.patientLink(form?.id ?? '', assignmentId),
    // Deliberately ignores `signal`: minting is a write, so it finishes and caches even if the drawer closes.
    queryFn: async () => (await resolvePatientFormToken(form!, assignmentId)) ?? '',
    enabled: Boolean(form && !existing && assignmentId),
    staleTime: 10 * 60_000,
  });

  return {
    accessToken: existing || query.data || '',
    isLoading: Boolean(form && !existing && assignmentId && query.isLoading),
  };
}
